import { createContext } from 'react-router';

import type { SessionPlQueryReturnData } from '~/services/ClientServiceTS';

/** Session data resolved by layout middleware for the current navigation. */
export const sessionContext = createContext<SessionPlQueryReturnData>();
